import React, { type MutableRefObject } from 'react';

import { Button } from '../../../../components';
import SharedInsuredFormSection, {
  type SharedInsuredFormSectionLabels,
} from '../../../../components/pagesComponents/vidaPageComponents/SharedInsuredFormSection';
import type { NewInsuredFormValues } from '../../../../types/vida/cadastralMaintenance/newInsuredFormTypes';
import type { PersonFormSection, PersonFormSectionControl } from '../../../../types/vida/cadastralMaintenance/personFormTypes';

type SeguradoFormSectionProps = {
  onValidityChange?: (isValid: boolean) => void;
  onValuesChange?: (values: NewInsuredFormValues) => void;
  initialValues?: NewInsuredFormValues;
  readOnly?: boolean;
  showDataCadastro?: boolean;
  cpfReadOnly?: boolean;
  dataCadastroReadOnly?: boolean;
  showBeneficiariosButton?: boolean;
  isBeneficiariosActive?: boolean;
  onBeneficiariosClick?: () => void;
  showConjugueButton?: boolean;
  isConjugueActive?: boolean;
  onConjugueClick?: () => void;
  onExitExtraPanels?: () => void;
  hideNavButtons?: boolean;
  extraNavButtons?: React.ReactNode;
  sectionControlRef?: MutableRefObject<PersonFormSectionControl | null>;
  onActiveSectionChange?: (section: PersonFormSection) => void;
};

const SeguradoFormSection: React.FC<SeguradoFormSectionProps> = ({
  onValidityChange,
  onValuesChange,
  initialValues,
  readOnly = false,
  showDataCadastro = false,
  cpfReadOnly = false,
  dataCadastroReadOnly = false,
  showBeneficiariosButton = false,
  isBeneficiariosActive = false,
  onBeneficiariosClick,
  showConjugueButton = false,
  isConjugueActive = false,
  onConjugueClick,
  onExitExtraPanels,
  hideNavButtons = false,
  extraNavButtons,
  sectionControlRef,
  onActiveSectionChange,
}) => {
  const labels: SharedInsuredFormSectionLabels = {
    personDataButton: 'Dados do Titular',
    personDataAriaLabel: 'Exibir dados do titular',
    personDataTitle: 'Dados do Titular',
    personAddressButton: 'Endereço do Titular',
    personAddressAriaLabel: 'Exibir endereço do titular',
    personAddressTitle: 'Endereço do Titular',
    insuranceInfoButton: 'Dados Empresariais',
    insuranceInfoAriaLabel: 'Exibir dados empresariais',
    insuranceInfoTitle: 'Dados Empresariais',
  };

  const hideFormSections = isBeneficiariosActive || isConjugueActive;

  const beneficiariosButton = showBeneficiariosButton ? (
    <Button
      type="button"
      color="primary"
      fill={isBeneficiariosActive ? 'solid' : 'outline'}
      onClick={onBeneficiariosClick}
      aria-label="Exibir beneficiários do segurado"
      aria-pressed={isBeneficiariosActive}
    >
      Beneficiários
    </Button>
  ) : null;

  const conjugueButton = showConjugueButton ? (
    <Button
      type="button"
      color="primary"
      fill={isConjugueActive ? 'solid' : 'outline'}
      onClick={onConjugueClick}
      aria-label="Exibir cônjuge do segurado"
      aria-pressed={isConjugueActive}
    >
      Cônjuge
    </Button>
  ) : null;

  return (
    <SharedInsuredFormSection
      labels={labels}
      onValidityChange={onValidityChange}
      onValuesChange={onValuesChange}
      initialValues={initialValues}
      readOnly={readOnly}
      showDataCadastro={showDataCadastro}
      cpfReadOnly={cpfReadOnly}
      dataCadastroReadOnly={dataCadastroReadOnly}
      hideNavButtons={hideNavButtons}
      extraNavButtons={(
        <>
          {beneficiariosButton}
          {conjugueButton}
          {extraNavButtons}
        </>
      )}
      hideFormSections={hideFormSections}
      onSectionNavChange={() => onExitExtraPanels?.()}
      sectionControlRef={sectionControlRef}
      onActiveSectionChange={onActiveSectionChange}
    />
  );
};

export default SeguradoFormSection;
